<template>
  <transition name="modal">
    <div class="home-div" v-if="isVisible" @click.self="closeModal">
    <div class="table-container">
    <el-table
      :data="tableData"
      border
      stripe
      style="width: auto;"
      v-loading="loading"
      @sort-change="handleSortChange"
    >
      <!-- 选择列 -->
      <el-table-column
        v-if="showSelection"
        type="selection"
        width="55"
      ></el-table-column>
      
      <!-- 序号列 -->
      <el-table-column
        v-if="showIndex"
        type="index"
        label="序号"
        width="60"
      ></el-table-column>
      
      <!-- 动态列 -->
      <template v-for="(column, index) in columns">
        <el-table-column
           v-if="column.prop !== 'id'"
          :key="index"
          :prop="column.prop"
          :label="column.label"
          :width="column.width"
          :min-width="column.minWidth"
          :align="column.align"
          :sortable="column.sortable || false"
        >
          <template #default="scope">
            <!-- 图片类型 -->
            <template v-if="column.type === 'image'">
              <el-image
                v-if="scope.row[column.prop]"
                style="width: 60px; height: 60px"
                :src="getImageUrl(scope.row[column.prop])"
                :preview-src-list="[getImageUrl(scope.row[column.prop])]"
                fit="cover"
                hide-on-click-modal
              ></el-image>
              <span v-else>-</span>
            </template>
            
            <!-- 链接类型 -->
            <template v-else-if="column.type === 'link'">
              <el-link
                type="primary"
                :href="scope.row[column.prop]"
                target="_blank"
                v-if="scope.row[column.prop]"
              >
                {{ column.linkText || '查看' }}
              </el-link>
              <span v-else>-</span>
            </template>
            
            <!-- 状态标签类型 -->
            <template v-else-if="column.type === 'status' || column.type === 'qsStatus'">
              <el-tag
                :type="getStatusType(scope.row[column.prop], column.statusOptionVos)"
                size="small"
              >
                {{ getStatusText(scope.row[column.prop], column.statusOptionVos) }}
              </el-tag>
            </template>
            
            <!-- 操作按钮类型 -->
            <template v-else-if="column.type === 'action'">
              <el-button
                v-for="(action, i) in column.actionVos"
                :key="i"
                :type="action.type || 'primary'"
                :icon="action.icon"
                size="small"
                @click="handleAction(action.event, scope.row)"
              >
                {{ action.text }}
              </el-button>
            </template>
            
            <!-- 默认文本类型 -->
            <template v-else>
              {{ scope.row[column.prop] || '-' }}
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
    
    <!-- 分页 -->
    <div class="pagination-container" v-if="showPagination">
      <el-pagination
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        :page-sizes="[5]"
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
      <div>
        <el-button
        type="primary"
        size="small"
        @click="closeModal"
      >
        关闭窗口
      </el-button>
    </div>
    </div>
  </div>
    </div>
    </transition>
</template>

<script>
export default {
  name: 'AdminTableDisplay',
  props: {
    eventType: {
      type: String,
      default: ""
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    // 表格列配置
    columns: {
      type: Array,
      required: true,
      default: () => []
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    // 是否显示选择列
    showSelection: {
      type: Boolean,
      default: true
    },
    // 是否显示序号列
    showIndex: {
      type: Boolean,
      default: true
    },
    // 是否显示分页
    showPagination: {
      type: Boolean,
      default: true
    },
    // 总条数
    total: {
      type: Number,
      default: 0
    },
    // 当前页码
    page: {
      type: Number,
      default: 1
    },
    // 每页条数
    limit: {
      type: Number,
      default: 5
    },
    // 加载状态
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['page-change', 'size-change', 'sort-change', 'action-event'],
  data() {
    return {
      currentPage: this.page,
      pageSize: this.limit
    }
  },
  created() {
  },
  watch: {
    page(val) {
      this.currentPage = val
    },
    limit(val) {
      this.pageSize = val
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:visible', false);
    },
    // 处理分页大小变化
    handleSizeChange(val) {
      this.$emit('size-change', val)
    },
    // 处理页码变化
    handleCurrentChange(val) {
      this.$emit('page-change', val)
    },
    // 处理排序变化
    handleSortChange({ column, prop, order }) {
      this.$emit('sort-change', { prop, order })
    },
    // 处理操作按钮事件
    handleAction(event, row) {
      this.$emit('action-event', { event, row })
    },
    // 获取图片URL（可根据实际项目调整）
    getImageUrl(url) {
      if (!url) return ''
      if (url.startsWith('http')){
        return url;
      }
      return `${process.env.VUE_APP_BASE_API}${url}`
    },
    // 获取状态文本
    getStatusText(value, options) {
      if (!options) return value
      const option = options.find(item => item.value === value)
      return option ? option.label : value
    },
    // 获取状态类型
    getStatusType(value, options) {
      if (!options) return ''
      const option = options.find(item => item.value === value)
      return option ? option.type || '' : ''
    }
  }
}
</script>

<style scoped>

.home-div{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
.table-container {
  width: auto;
  height: 80%;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 0 !important;
}

.el-pagination{
  padding: 0 !important;
  margin: 0 !important;
}



@media (max-width: 768px) {
  .table-container {
    width: 90% !important;
    height: 100% !important;
    margin-top: 30% !important;
  }

  .pagination-container {
    width: 100% !important;
    flex-wrap: wrap;
    justify-content: space-around;
}
}

</style>